// Components
import Text from 'components/common/Text';
import Image from 'next/image';

// Libs
import Translation from 'libs/Translation';

const CenterBio = ({ center, mobileView }) => {

return (
<div className="box">
    <div 
        className='header'
    >
        <Image
            src={center?.coverImage ? center.coverImage?.fileUrl : '/nextasset/images/center/Cover.png'}
            alt={center.Name}
            layout='fill'
            objectFit='cover'
            priority={true}
            className="cover"
        />
        <div className="center-image">
            {mobileView ?
            <Image
                src={center?.profileImage ? center.profileImage?.fileUrl : '/nextasset/images/center/avatar.jpeg'}
                alt={center.Name}
                width={64}
                height={64}
                priority={true}
                className="img"
            />
            :
            <Image
                src={center?.profileImage ? center.profileImage?.fileUrl : '/nextasset/images/center/avatar.jpeg'}
                alt={center.Name}
                width={96}
                height={96}
                priority={true}
                className="img"
            />
            }       
        </div>
    </div>
    <div className='padding-24'>
        <div className='column-flex flex-start gap-5'>
            {center?.Name &&
            <Text 
                color="#282B2E"
                className="name"
                tag="h1"
            >
                {center.Name}
            </Text>
            }
            {center?.AboutTitle &&
            <Text 
                color="#72767A"
                tag="h2"
                className="description"
            >
               {Translation.n(center.AboutTitle)}
            </Text>
            }
            {center?.About &&
            <>
            <div className='row-flex flex-title'>
                {mobileView ?
                <Image
                    src="/nextasset/images/center/icon.png"
                    width={28}
                    height={28}
                    alt="text-icon"
                />
                :
                <Image
                    src="/nextasset/images/center/icon.png"
                    width={32}
                    height={32}
                    alt="text-icon"
                />
                }
                <Text 
                    color="#0D2439"
                    className="title"
                >
                    {Translation.t('title.about-')}
                </Text>
            </div>
            <div 
                className='about'
                dangerouslySetInnerHTML={{__html: Translation.n(center.About)}} 
            />
            </>}
            {center?.images?.length ?
            <>
            <Text 
                color="#0D2439"
                className="title"
            >
                {Translation.t('title.pictures')}
            </Text>
            <div 
                className="pictures"
            >     
                {center.images.map(i => (
                <>
                    {mobileView ?
                    <Image
                        key={i._id}
                        src={i.fileUrl}
                        alt={center?.Name}
                        width={48}
                        height={48}
                        className='img'
                    />
                    :
                    <Image
                        key={i._id}
                        src={i.fileUrl}
                        alt={center?.Name}
                        width={64}
                        height={64}
                        className='img'
                    />
                    }
                </>
                ))}
            </div>
            </>
            : null
            } 
        </div>
    </div>
</div>
    )
}
export default CenterBio;